<template lang='pug'>
v-row.train-detail.mb-5(v-for="(train, it) in trains" :key="it")
	v-col.tw-pt-8(md="3")
		.tw-text-center.tw-mb-2(v-if="!loading && departures && it > 0 && departures[it] != departures[0]") {{departures[it]}}
		.tw-flex.tw-align-start.tw-justify-center.tw-w-full(v-if='loading')
			v-progress-circular(indeterminate color="primary-darken-1")
		div.tw-mt-5(v-if="solution.trainsStops && solution.trainsStops[it]")
			v-row.train-stops.align-center.ma-0.py-0(v-for="(stop, is) in solution.trainsStops[it]" :key="is")
				v-col.text-right.stops-hours {{stop.arrival}}
					br
					| {{stop.departure}}
				v-col.stops-bar.bg-primary(class="tw-max-w-[24px]")
					div
						.circle(v-if="is == 0 || is == (solution.trainsStops[it].length - 1)")
							span.mdi.mdi-circle
						.circle(v-else)
							span.mdi.mdi-circle-outline
				v-col.stops-station {{stop.station}}
	v-col.tw-pt-8
		v-card.align-center(color="blue-grey lighten-5")
			v-card-title
				h3 {{train.type}} {{train.name}}
					small ( {{train.duration}} )
			v-card-text
				div(v-if="train.info.length > 0")
					h3.mb-5 {{$t('sale.travel_solution_detail.services', 'SERVIZI')}}
					template(v-for="(info, ii) in train.info" :key="ii")
						v-row(v-if="info.type != 'Nota Informativa' && info.description != '[]' && info.description.length > 0")
							v-col.justify-center.d-flex.align-center(class="tw-basis-1/12 emd:tw-basis-2/12")
								img(:src="'data:image/png;base64,  '+info.image.data" v-if="info.image !== null")
							v-col(class="tw-basis-11/12 emd:tw-basis-10/12") {{info.description}}
					v-divider.ma-6
					template(v-for="(info, ii) in train.info" :key="ii")
						ul(v-if="info.type == 'Nota Informativa' && info.description && info.description != '[]'")
							li {{info.description}}
				h3.tw-mb-5.tw-text-center.tw-font-bold.tw-italic(v-else) {{$t('common.no_info', 'SPIACENTI PER QUESTA TRATTA NON SI HANNO INFORMAZIONI')}}
</template>

<script setup>
import { getTrainBreadcrumbs } from '@/common-scripts/train-helper';
import { computed } from 'vue';

const {solution, loading} = defineProps({
	solution: Object,
	loading: Boolean
});
const trains = computed(() => getTrainBreadcrumbs(solution && solution.trains))
const departures = computed(() => {
	if (!trains.value) return ;
	let departures = [];
	for (const k in trains.value) {
		departures[k] = new Date(trains.value[k].departure).toLocaleDateString(undefined, {day: '2-digit', month: '2-digit', year:'numeric'});
	}
	return departures;
});
</script>

<style scoped>
.train-detail .v-card .col {
  padding-top: 4px;
  padding-bottom: 4px;
}
.train-detail .v-card ul {
  margin-bottom: 3px;
}
.train-detail .v-card ul > li {
  font-size: 0.75rem;
  line-height: 0.9rem;
}
h3 > small {
  font-size: 0.9rem;
}
.train-stops {
  font-size: 0.875rem;
}
.train-stops:first-child .stops-bar {
  border-radius: 20px 20px 0 0;
}
.train-stops .stops-bar {
  align-items: center;
  color: #ffffff;
  display: flex;
  height: 80px;
  justify-content: center;
  width: 20px;
}
.train-stops:last-child .stops-bar {
  border-radius: 0 0 20px 20px;
}
.train-stops .col:last-child {
  font-weight: 600;
}
.stops-station {
	max-width: 200px;
}
.stops-hours {
	max-width: 55px;
	min-width: 55px;
}
</style>